'use strict';
/*
  Stores 
/*---------------------------------------*/
import * as types from './mutations/map-mutations';
import configs from './configs/map-configs';
import mapLayer from './map-layer';
import localForage from 'localforage';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
// import Vue from 'vue';
dayjs.locale('ja');

/*
  Init Store 
/*---------------------------------------*/
export default new Vuex.Store({
  /*
    States 
  /*---------------------------------------*/
  state: () => ({
    //- Configs
    logo_url: `${baseUrl}/assets/common/logo.png`,
    storage: process.env.GOOGLE_KML_STORAGE,
    map: null,
    latitude: 39.313828,
    longitude: 140.566588,
    zoom_default: 14,
    zoom_in: 14,
    current_position: null,
    map_options: {
      zoomControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      zIndex: 9999999,
      styles: configs.style,
      maxZoom: 16,
      minZoom: 10,
    },
    message: null,
    memo: '',
    is_winter: [11, 0, 1, 2].includes(dayjs().month()),
    //- Layers
    sediment_layers: null,
    tameike_layers: null,
    // hazard_layer: null,
    hazard_extends_minase_naruse_omonogawa_layer: null,
    hazard_extends_minase_naruse_omonogawa_soukihinan_layer: null,
    hazard_extends_yokotegawa_layer: null,
    hazard_extends_yokotegawa_soukihinan_layer: null,
    hazard_extends_uwamizo_layer: null,
    hazard_extends_saragawa_layer: null,
    hazard_extends_ootogawa_layer: null,
    hazard_extends_kashiranashigawa_layer: null,
    hazard_extends_budougawa_layer: null, // 武道川(山内)
    hazard_extends_iwanomesawa_layer: null, // 岩ノ間川
    hazard_extends_kuriyagawa_layer: null, // 厨川
    hazard_extends_kurosawagawa_layer: null, // 黒沢川
    hazard_extends_matsukawa_layer: null, // 松川
    hazard_extends_minasegawa_layer: null, // 皆瀬川
    hazard_extends_naraokagawa_layer: null, // 奈良岡川
    hazard_extends_narusegawa_layer: null, // 成田下川
    hazard_extends_sakabegawa_layer: null, // 酒匂川
    hazard_extends_shirakogawa_layer: null, // 白子川
    hazard_extends_sugisawagawa_layer: null, // 杉沢川
    hazard_extends_ugoootogawa_layer: null, // 牛尾田川
    hazard_extends_yokotegawasannai_layer: null, // 横手川上流域
    hazard_extends_nakanomekawa_layer: null, // 中野川
    hazard_extends_imokawa_layer: null, // 井戸川
    snowd_layer: null,
    ekijyoka_layer: null,
    raind_layer: null,
    kikikuru_layer: null,
    shelter_markers: null,
    custom_layers: null,
    closed_shelter_markers: null,
    offcanvas_is_show: false,

    //- is_visible
    is_visible: {
      sediment_layers: true,
      tameike_layers: false,
      all_hazard_layers: true,
      // hazard_layer: true,
      hazard_extends_all_layers: true,
      hazard_extends_minase_naruse_omonogawa_layer: true,
      hazard_extends_minase_naruse_omonogawa_soukihinan_layer: true,
      hazard_extends_yokotegawa_layer: true,
      hazard_extends_yokotegawa_soukihinan_layer: true,
      hazard_extends_uwamizo_layer: true,
      hazard_extends_saragawa_layer: true,
      hazard_extends_ootogawa_layer: true,
      hazard_extends_kashiranashigawa_layer: true,
      hazard_extends_budougawa_layer: true,
      hazard_extends_iwanomesawa_layer: true,
      hazard_extends_kuriyagawa_layer: true,
      hazard_extends_kurosawagawa_layer: true,
      hazard_extends_matsukawa_layer: true,
      hazard_extends_minasegawa_layer: true,
      hazard_extends_naraokagawa_layer: true,
      hazard_extends_narusegawa_layer: true,
      hazard_extends_sakabegawa_layer: true,
      hazard_extends_shirakogawa_layer: true,
      hazard_extends_sugisawagawa_layer: true,
      hazard_extends_ugoootogawa_layer: true,
      hazard_extends_yokotegawasannai_layer: true,
      hazard_extends_nakanomekawa_layer: true,
      hazard_extends_imokawa_layer: true,
      shelter_markers: true,
      closed_shelter_markers: false,
      custom_layers: true,
      snowd_layer: false,
      ekijyoka_layer: false,
      raind_layer: false,
      kikikuru_layer: false,
    },

    visible_settings_by_user: {
      hazard_layer: true,
    },
    //- Guides
    guides: configs.guides,
    guide_is_show: true,
    target_times: {
      snowd_target_time: null,
      raind_target_time: null,
      kikikuru_target_time: null,
    },
  }),

  /*
    Getters 
  /*---------------------------------------*/
  getters: {
    //- for old system
    center: (state) => ({
      lat: state.latitude,
      lng: state.longitude,
    }),
    zoom_default: (state) => state.zoom_default,
    map_options: (state) => state.map_options,

    //- Configs
    logoUrl: (state) => state.logo_url,
    current_position: (state) => state.current_position,
    offcanvas_is_show: (state) => state.offcanvas_is_show,
    message: (state) => state.message,
    memo: (state) => state.memo,
    is_winter: (state) => state.is_winter,
    attribution: (state) => configs.attribution,

    //- Visible State for Layers
    sediment_layers_is_show: (state) => state.is_visible.sediment_layers,
    tameike_layers_is_show: (state) => state.is_visible.tameike_layers,
    all_hazard_layers_is_show: (state) => state.is_visible.all_hazard_layers,
    // hazard_layer_is_show: (state) => state.is_visible.hazard_layer, // 気象庁
    hazard_extends_minase_naruse_omonogawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_minase_naruse_omonogawa_layer,
    hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show: (state) =>
      state.is_visible.hazard_extends_minase_naruse_omonogawa_soukihinan_layer,
    hazard_extends_yokotegawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_yokotegawa_layer,
    hazard_extends_yokotegawa_soukihinan_layer_is_show: (state) =>
      state.is_visible.hazard_extends_yokotegawa_soukihinan_layer,
    hazard_extends_uwamizo_layer_is_show: (state) => state.is_visible.hazard_extends_uwamizo_layer,
    hazard_extends_saragawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_saragawa_layer,
    hazard_extends_ootogawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_ootogawa_layer,
    hazard_extends_kashiranashigawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_kashiranashigawa_layer,
    hazard_extends_budougawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_budougawa_layer,
    hazard_extends_iwanomesawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_iwanomesawa_layer,
    hazard_extends_kuriyagawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_kuriyagawa_layer,
    hazard_extends_kurosawagawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_kurosawagawa_layer,
    hazard_extends_matsukawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_matsukawa_layer,
    hazard_extends_minasegawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_minasegawa_layer,
    hazard_extends_naraokagawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_naraokagawa_layer,
    hazard_extends_narusegawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_narusegawa_layer,
    hazard_extends_sakabegawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_sakabegawa_layer,
    hazard_extends_shirakogawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_shirakogawa_layer,
    hazard_extends_sugisawagawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_sugisawagawa_layer,
    hazard_extends_ugoootogawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_ugoootogawa_layer,
    hazard_extends_yokotegawasannai_layer_is_show: (state) =>
      state.is_visible.hazard_extends_yokotegawasannai_layer,
    hazard_extends_nakanomekawa_layer_is_show: (state) =>
      state.is_visible.hazard_extends_nakanomekawa_layer,
    hazard_extends_imokawa_layer_is_show: (state) => state.is_visible.hazard_extends_imokawa_layer,
    hazard_extends_imokawa_layer_is_show: (state) => state.is_visible.hazard_extends_imokawa_layer,
    kikikuru_layer_is_show: (state) => state.is_visible.kikikuru_layer,
    snowd_layer_is_show: (state) => state.is_visible.snowd_layer,
    ekijyoka_layer_is_show: (state) => state.is_visible.ekijyoka_layer,
    raind_layer_is_show: (state) => state.is_visible.raind_layer,
    shelter_markers_is_show: (state) => state.is_visible.shelter_markers,
    closed_shelter_markers_is_show: (state) => state.is_visible.closed_shelter_markers,
    custom_layers_is_show: (state) => state.is_visible.custom_layers,

    //- Layers
    custom_layers_list: (state) => {
      if (!state.custom_layers || state.custom_layers?.length <= 0) return [];
      const list = {};
      state.custom_layers.forEach((custom_layer) => {
        try {
          const area = custom_layer.props.area;
          if (!list.hasOwnProperty(area)) {
            list[area] = [];
          }
          list[area].push(custom_layer);
        } catch (e) {
          console.log('error occur: store.js > getters > custom_layers_list:', e);
        }
      });
      return list;
    },

    //- Openshelters
    open_shelters_list: (state) => {
      if (!state.shelter_markers || state.shelter_markers?.length <= 0) return [];
      const list = {};
      state.shelter_markers.forEach((shelter) => {
        try {
          const area = shelter.props.area; //- alt is area
          if (!list.hasOwnProperty(area)) {
            list[area] = [];
          }
          list[area].push(shelter);
        } catch (e) {
          console.log('error occur: store.js > getters > open_shelters_list:', e);
        }
      });
      return list;
    },

    //- Guides
    guides: (state) => state.guides,
    guide_is_show: (state) => state.guide_is_show,
    target_times: (state) => state.target_times,
  },

  /*
    Mutations 
  /*---------------------------------------*/
  mutations: {
    [types.INIT_MAP](state, args) {
      //- Map
      state.map = args.map;
      //- Layers
      state.sediment_layers = args.sediment_layers;
      state.tameike_layers = args.tameike_layers;
      // state.hazard_layer = args.hazard_layer;
      state.hazard_extends_minase_naruse_omonogawa_layer =
        args.hazard_extends_minase_naruse_omonogawa_layer;
      state.hazard_extends_minase_naruse_omonogawa_soukihinan_layer =
        args.hazard_extends_minase_naruse_omonogawa_soukihinan_layer;
      state.hazard_extends_yokotegawa_layer = args.hazard_extends_yokotegawa_layer;
      state.hazard_extends_yokotegawa_soukihinan_layer =
        args.hazard_extends_yokotegawa_soukihinan_layer;
      state.hazard_extends_uwamizo_layer = args.hazard_extends_uwamizo_layer;
      state.hazard_extends_saragawa_layer = args.hazard_extends_saragawa_layer;
      state.hazard_extends_ootogawa_layer = args.hazard_extends_ootogawa_layer;
      state.hazard_extends_kashiranashigawa_layer = args.hazard_extends_kashiranashigawa_layer;
      state.hazard_extends_budougawa_layer = args.hazard_extends_budougawa_layer;
      state.hazard_extends_iwanomesawa_layer = args.hazard_extends_iwanomesawa_layer;
      state.hazard_extends_kuriyagawa_layer = args.hazard_extends_kuriyagawa_layer;
      state.hazard_extends_kurosawagawa_layer = args.hazard_extends_kurosawagawa_layer;
      state.hazard_extends_matsukawa_layer = args.hazard_extends_matsukawa_layer;
      state.hazard_extends_minasegawa_layer = args.hazard_extends_minasegawa_layer;
      state.hazard_extends_naraokagawa_layer = args.hazard_extends_naraokagawa_layer;
      state.hazard_extends_narusegawa_layer = args.hazard_extends_narusegawa_layer;
      state.hazard_extends_sakabegawa_layer = args.hazard_extends_sakabegawa_layer;
      state.hazard_extends_shirakogawa_layer = args.hazard_extends_shirakogawa_layer;
      state.hazard_extends_sugisawagawa_layer = args.hazard_extends_sugisawagawa_layer;
      state.hazard_extends_ugoootogawa_layer = args.hazard_extends_ugoootogawa_layer;
      state.hazard_extends_yokotegawasannai_layer = args.hazard_extends_yokotegawasannai_layer;
      state.hazard_extends_nakanomekawa_layer = args.hazard_extends_nakanomekawa_layer;
      state.hazard_extends_imokawa_layer = args.hazard_extends_imokawa_layer;
      state.snowd_layer = args.snowd_layer;
      state.ekijyoka_layer = args.ekijyoka_layer;
      state.raind_layer = args.raind_layer;
      state.kikikuru_layer = args.kikikuru_layer;
      state.shelter_markers = args.shelter_markers;
      state.closed_shelter_markers = args.closed_shelter_markers;
      state.custom_layers = args.custom_layers;
      //- Position
      state.current_position = args.current_position;
      //- Target Times
      state.target_times.snowd_target_time = args.snowd_target_time;
      state.target_times.raind_target_time = args.raind_target_time;
      state.target_times.kikikuru_target_time = args.kikikuru_target_time;
    },

    [types.TOGGLE_OFFCANVAS](state, is_show) {
      if (is_show != null) {
        state.offcanvas_is_show = is_show;
      } else {
        state.offcanvas_is_show = !state.offcanvas_is_show;
      }
    },

    [types.TOGGLE_GUIDE](state) {
      state.guide_is_show = !state.guide_is_show;
    },

    [types.SET_MESSAGE](state, message) {
      state.message = message;
    },

    [types.SET_MEMO](state, memo) {
      state.memo = memo;
      localForage.setItem('memo', state.memo);
    },

    [types.TOGGLE_LAYER](state, args) {
      state.is_visible[args.layer_name] =
        args.state !== undefined ? args.state : !state.is_visible[args.layer_name];
    },
    [types.VISIBLE_SETTINGS_BY_USER](state, args) {
      state.visible_settings_by_user[args.layer_name] = args.state;
    },
  },

  /*
    Actions 
  /*---------------------------------------*/
  actions: {
    async [types.INIT_MAP]({ state, commit, dispatch }) {
      /*
        Memo 
      /*---------------------------------------*/
      localForage.getItem('memo').then((memo) => {
        commit(types.SET_MEMO, memo);
      });

      /*
        INIT MAP
      /*---------------------------------------*/
      const mapOptions = {
        maxZoom: 16,
        minZoom: 10,
        zoomControl: false,
        attributionControl: false,
      };
      if (configs.area_limit_is_enabled) {
        const corner1 = L.latLng(configs.bound_for_limit.north, configs.bound_for_limit.west);
        const corner2 = L.latLng(configs.bound_for_limit.south, configs.bound_for_limit.east);
        mapOptions.maxBounds = L.latLngBounds(corner1, corner2);
      }
      const map = L.map('hazardmap', mapOptions);
      map.setView([state.latitude, state.longitude], state.zoom_default);

      /*
        LOAD GOOGLE MAP
      /*---------------------------------------*/
      const gmapLayer = L.gridLayer
        .googleMutant(
          {
            type: 'roadmap',
            styles: state.map_options.styles,
          },
          { attribution: configs.attribution },
        )
        .addTo(map);

      /*
        Popup event Handler 
      /*---------------------------------------*/
      map.on('popupopen', (event) => {
        map.panTo(event.popup._latlng);
      });

      /*
        GET CURRENT POSITION
      /*---------------------------------------*/
      let current_position;
      try {
        const current_position_promise = await new Promise((resolve, reject) =>
          navigator.geolocation.getCurrentPosition(resolve, reject),
        );
        current_position = {
          lat: current_position_promise.coords.latitude,
          lng: current_position_promise.coords.longitude,
        };
        const current_marker = await mapLayer.load.current_position(current_position);
        current_marker.addTo(map);
        map.panTo(current_position);
      } catch (e) {
        current_position = null;
      }

      /*
        Load Layers
      /*---------------------------------------*/
      const sediment_layers = mapLayer.load.sediments();
      const tameike_layers = await mapLayer.load.tameike();
      // const hazard_layer = mapLayer.load.hazard();
      // const hazard_extends_layer = mapLayer.load.hazard_extends();
      const hazard_extends_minase_naruse_omonogawa_layer = mapLayer.load.hazard_extends_minase_naruse_omonogawa();
      const hazard_extends_minase_naruse_omonogawa_soukihinan_layer = mapLayer.load.hazard_extends_minase_naruse_omonogawa_soukihinan();
      const hazard_extends_yokotegawa_layer = mapLayer.load.hazard_extends_yokotegawa();
      const hazard_extends_yokotegawa_soukihinan_layer = mapLayer.load.hazard_extends_yokotegawa_soukihinan();
      const hazard_extends_uwamizo_layer = mapLayer.load.hazard_extends_uwamizo();
      const hazard_extends_saragawa_layer = mapLayer.load.hazard_extends_saragawa();
      const hazard_extends_ootogawa_layer = mapLayer.load.hazard_extends_ootogawa();
      const hazard_extends_kashiranashigawa_layer = mapLayer.load.hazard_extends_kashiranashigawa();
      const hazard_extends_budougawa_layer = mapLayer.load.hazard_extends_budougawa();
      const hazard_extends_iwanomesawa_layer = mapLayer.load.hazard_extends_iwanomesawa();
      const hazard_extends_kuriyagawa_layer = mapLayer.load.hazard_extends_kuriyagawa();
      const hazard_extends_kurosawagawa_layer = mapLayer.load.hazard_extends_kurosawagawa();
      const hazard_extends_matsukawa_layer = mapLayer.load.hazard_extends_matsukawa();
      const hazard_extends_minasegawa_layer = mapLayer.load.hazard_extends_minasegawa();
      const hazard_extends_naraokagawa_layer = mapLayer.load.hazard_extends_naraokagawa();
      const hazard_extends_narusegawa_layer = mapLayer.load.hazard_extends_narusegawa();
      const hazard_extends_sakabegawa_layer = mapLayer.load.hazard_extends_sakabegawa();
      const hazard_extends_shirakogawa_layer = mapLayer.load.hazard_extends_shirakogawa();
      const hazard_extends_sugisawagawa_layer = mapLayer.load.hazard_extends_sugisawagawa();
      const hazard_extends_ugoootogawa_layer = mapLayer.load.hazard_extends_ugoootogawa();
      const hazard_extends_yokotegawasannai_layer = mapLayer.load.hazard_extends_yokotegawasannai();
      const hazard_extends_nakanomekawa_layer = mapLayer.load.hazard_extends_nakanomekawa();
      const hazard_extends_imokawa_layer = mapLayer.load.hazard_extends_imokawa();
      const snowd = await mapLayer.load.snowd();
      const snowd_layer = snowd.layer;
      const ekijyoka_layer = await mapLayer.load.ekijyoka();
      const snowd_target_time = snowd.target_time;
      const raind = await mapLayer.load.raind();
      const raind_layer = raind.layer;
      const raind_target_time = raind.target_time;
      const kikikuru = await mapLayer.load.kikikuru();
      const kikikuru_layer = kikikuru.layer;
      const kikikuru_target_time = kikikuru.target_time;
      const shelters = await mapLayer.load.shelters(current_position);
      const shelter_markers = shelters.shelter_markers;
      const closed_shelter_markers = shelters.closed_shelter_markers;
      const custom_layers = await mapLayer.load.customs();

      /*
        初期表示レイヤー
      /*---------------------------------------*/
      sediment_layers.addTo(map);
      // hazard_layer.addTo(map);
      hazard_extends_minase_naruse_omonogawa_layer.addTo(map);
      hazard_extends_minase_naruse_omonogawa_soukihinan_layer.addTo(map);
      hazard_extends_uwamizo_layer.addTo(map);
      hazard_extends_yokotegawa_layer.addTo(map);
      hazard_extends_yokotegawa_soukihinan_layer.addTo(map);
      hazard_extends_saragawa_layer.addTo(map);
      hazard_extends_ootogawa_layer.addTo(map);
      hazard_extends_kashiranashigawa_layer.addTo(map);
      hazard_extends_budougawa_layer.addTo(map);
      hazard_extends_iwanomesawa_layer.addTo(map);
      hazard_extends_kuriyagawa_layer.addTo(map);
      hazard_extends_kurosawagawa_layer.addTo(map);
      hazard_extends_matsukawa_layer.addTo(map);
      hazard_extends_minasegawa_layer.addTo(map);
      hazard_extends_naraokagawa_layer.addTo(map);
      hazard_extends_narusegawa_layer.addTo(map);
      hazard_extends_sakabegawa_layer.addTo(map);
      hazard_extends_shirakogawa_layer.addTo(map);
      hazard_extends_sugisawagawa_layer.addTo(map);
      hazard_extends_ugoootogawa_layer.addTo(map);
      hazard_extends_yokotegawasannai_layer.addTo(map);
      hazard_extends_nakanomekawa_layer.addTo(map);
      hazard_extends_imokawa_layer.addTo(map);
      shelter_markers.forEach((shelter_marker) => {
        shelter_marker.addTo(map);
      });
      custom_layers.forEach((custom_layer) => {
        custom_layer.addTo(map);
      });

      /*
        Commit Map and Layers, Markers
      /*---------------------------------------*/
      commit(types.INIT_MAP, {
        map,
        sediment_layers,
        tameike_layers,
        // hazard_layer,
        // hazard_extends_layer,
        hazard_extends_minase_naruse_omonogawa_layer,
        hazard_extends_minase_naruse_omonogawa_soukihinan_layer,
        hazard_extends_uwamizo_layer,
        hazard_extends_yokotegawa_layer,
        hazard_extends_yokotegawa_soukihinan_layer,
        hazard_extends_saragawa_layer,
        hazard_extends_ootogawa_layer,
        hazard_extends_kashiranashigawa_layer,
        hazard_extends_budougawa_layer,
        hazard_extends_iwanomesawa_layer,
        hazard_extends_kuriyagawa_layer,
        hazard_extends_kurosawagawa_layer,
        hazard_extends_matsukawa_layer,
        hazard_extends_minasegawa_layer,
        hazard_extends_naraokagawa_layer,
        hazard_extends_narusegawa_layer,
        hazard_extends_sakabegawa_layer,
        hazard_extends_shirakogawa_layer,
        hazard_extends_sugisawagawa_layer,
        hazard_extends_ugoootogawa_layer,
        hazard_extends_yokotegawasannai_layer,
        hazard_extends_nakanomekawa_layer,
        hazard_extends_imokawa_layer,
        snowd_layer,
        ekijyoka_layer,
        raind_layer,
        kikikuru_layer,
        shelter_markers,
        closed_shelter_markers,
        custom_layers,
        current_position,
        snowd_target_time,
        raind_target_time,
        kikikuru_target_time,
      });
    },

    /*
      Toggle Layer
    /*---------------------------------------*/
    [types.TOGGLE_LAYER]({ state, commit }, args) {
      /*
        Layers 
        レイヤが単一オブジェクトの場合は配列として格納する
      /*---------------------------------------*/
      const layers =
        state[args.layer_name]?.length >= 0 ? state[args.layer_name] : [state[args.layer_name]];
      //- Toggle
      if (args.state) {
        layers.forEach((layer) => {
          layer?.addTo(state.map);
        });
      } else {
        layers.forEach((layer) => {
          layer?.remove();
        });
      }
      //- Commit Layer
      commit(types.TOGGLE_LAYER, args);

      /**
       * extends_layersが全て非表示の場合は、all_hazard_layersも非表示にする
       */
      const extends_layers = [
        // 'hazard_layer',
        'hazard_extends_minase_naruse_omonogawa_layer',
        'hazard_extends_minase_naruse_omonogawa_soukihinan_layer',
        'hazard_extends_uwamizo_layer',
        'hazard_extends_yokotegawa_layer',
        'hazard_extends_yokotegawa_soukihinan_layer',
        'hazard_extends_saragawa_layer',
        'hazard_extends_ootogawa_layer',
        'hazard_extends_kashiranashigawa_layer',
        'hazard_extends_budougawa_layer',
        'hazard_extends_iwanomesawa_layer',
        'hazard_extends_kuriyagawa_layer',
        'hazard_extends_kurosawagawa_layer',
        'hazard_extends_matsukawa_layer',
        'hazard_extends_minasegawa_layer',
        'hazard_extends_naraokagawa_layer',
        'hazard_extends_narusegawa_layer',
        'hazard_extends_sakabegawa_layer',
        'hazard_extends_shirakogawa_layer',
        'hazard_extends_sugisawagawa_layer',
        'hazard_extends_ugoootogawa_layer',
        'hazard_extends_yokotegawasannai_layer',
        'hazard_extends_nakanomekawa_layer',
        'hazard_extends_imokawa_layer',
      ];

      /**
       * state.is_visibleでextends_layersの全てが非表示の場合は、hazard_extends_all_layersも非表示にする
       */
      const extends_all_layers_is_show = extends_layers.some((layer) => !state.is_visible[layer]);
      commit(types.TOGGLE_LAYER, {
        layer_name: 'all_hazard_layers',
        state: !extends_all_layers_is_show,
      });
      // commit(types.TOGGLE_LAYER, {
      //   layer_name: 'hazard_extends_all_layers',
      //   state: !extends_all_layers_is_show,
      // });

      /*
        Push Event 
      /*---------------------------------------*/
      this._vm.$gtm.trackEvent({
        event: 'ToggleLayer',
        target: args.layer_name,
        value: args.state,
      });

      /*
        Kikikuru,Snowd,Raind and Hazard 
        フロントスイッチ操作で「キキクル」「今後の雪」「今後の雨」と「ハザード」の表示は同時に表示させない
      /*---------------------------------------*/
      if (args.type == 'front_switch') {
        if (args.state) {
          // state['hazard_layer'].remove();
          state['hazard_extends_minase_naruse_omonogawa_layer'].remove();
          state['hazard_extends_minase_naruse_omonogawa_soukihinan_layer'].remove();
          state['hazard_extends_uwamizo_layer'].remove();
          state['hazard_extends_yokotegawa_layer'].remove();
          state['hazard_extends_yokotegawa_soukihinan_layer'].remove();
          state['hazard_extends_saragawa_layer'].remove();
          state['hazard_extends_ootogawa_layer'].remove();
          state['hazard_extends_kashiranashigawa_layer'].remove();
          state['hazard_extends_budougawa_layer'].remove();
          state['hazard_extends_iwanomesawa_layer'].remove();
          state['hazard_extends_kuriyagawa_layer'].remove();
          state['hazard_extends_kurosawagawa_layer'].remove();
          state['hazard_extends_matsukawa_layer'].remove();
          state['hazard_extends_minasegawa_layer'].remove();
          state['hazard_extends_naraokagawa_layer'].remove();
          state['hazard_extends_narusegawa_layer'].remove();
          state['hazard_extends_sakabegawa_layer'].remove();
          state['hazard_extends_shirakogawa_layer'].remove();
          state['hazard_extends_sugisawagawa_layer'].remove();
          state['hazard_extends_ugoootogawa_layer'].remove();
          state['hazard_extends_yokotegawasannai_layer'].remove();
          state['hazard_extends_nakanomekawa_layer'].remove();
          state['hazard_extends_imokawa_layer'].remove();
        } else {
          //- 当該レイヤーが一つでも表示中の場合は、ハザードは表示させない
          if (
            state.is_visible.snowd_layer ||
            state.is_visible.kikikuru_layer ||
            state.is_visible.raind_layer
          ) {
            return;
          } else {
            //- Offcanvas内の操作でハザードレイヤーが非表示にされている場合は、それに従う
            if (state.visible_settings_by_user.hazard_layer) {
              // state['hazard_layer'].addTo(state.map);
              state['hazard_extends_minase_naruse_omonogawa_layer'].addTo(state.map);
              state['hazard_extends_minase_naruse_omonogawa_soukihinan_layer'].addTo(state.map);
              state['hazard_extends_uwamizo_layer'].addTo(state.map);
              state['hazard_extends_yokotegawa_layer'].addTo(state.map);
              state['hazard_extends_yokotegawa_soukihinan_layer'].addTo(state.map);
              state['hazard_extends_saragawa_layer'].addTo(state.map);
              state['hazard_extends_ootogawa_layer'].addTo(state.map);
              state['hazard_extends_kashiranashigawa_layer'].addTo(state.map);
              state['hazard_extends_budougawa_layer'].addTo(state.map);
              state['hazard_extends_iwanomesawa_layer'].addTo(state.map);
              state['hazard_extends_kuriyagawa_layer'].addTo(state.map);
              state['hazard_extends_kurosawagawa_layer'].addTo(state.map);
              state['hazard_extends_matsukawa_layer'].addTo(state.map);
              state['hazard_extends_minasegawa_layer'].addTo(state.map);
              state['hazard_extends_naraokagawa_layer'].addTo(state.map);
              state['hazard_extends_narusegawa_layer'].addTo(state.map);
              state['hazard_extends_sakabegawa_layer'].addTo(state.map);
              state['hazard_extends_shirakogawa_layer'].addTo(state.map);
              state['hazard_extends_sugisawagawa_layer'].addTo(state.map);
              state['hazard_extends_ugoootogawa_layer'].addTo(state.map);
              state['hazard_extends_yokotegawasannai_layer'].addTo(state.map);
              state['hazard_extends_nakanomekawa_layer'].addTo(state.map);
              state['hazard_extends_imokawa_layer'].addTo(state.map);
            } else {
              return;
            }
          }
        }
        //- Commit Hazard Layer
        // commit(types.TOGGLE_LAYER, {
        //   layer_name: 'hazard_layer',
        //   state: !args.state,
        // });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_all_layers',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minase_naruse_omonogawa_soukihinan_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawa_soukihinan_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_uwamizo_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_saragawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ootogawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kashiranashigawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_budougawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_iwanomesawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kuriyagawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_kurosawagawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_matsukawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_minasegawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_naraokagawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_narusegawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sakabegawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_shirakogawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_sugisawagawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_ugoootogawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_yokotegawasannai_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_nakanomekawa_layer',
          state: !args.state,
        });
        commit(types.TOGGLE_LAYER, {
          layer_name: 'hazard_extends_imokawa_layer',
          state: !args.state,
        });
      }
    },

    /*
      Visible settings by user (for hazard_layer that has high priority) 
    /*---------------------------------------*/
    [types.VISIBLE_SETTINGS_BY_USER]({ state, commit }, args) {
      commit(types.VISIBLE_SETTINGS_BY_USER, args);
    },

    /*
      Toggle Offcanvas 
    /*---------------------------------------*/
    [types.TOGGLE_OFFCANVAS]({ state, commit }) {
      /*
        Push Event 
      /*---------------------------------------*/
      this._vm.$gtm.trackEvent({
        event: 'ToggleOffcanvas',
        target: 'offcanvas',
        value: !state.offcanvas_is_show,
      });
      /*
        Commit 
      /*---------------------------------------*/
      commit(types.TOGGLE_OFFCANVAS);
    },

    /*
      SET CURRENT POSITION
    /*---------------------------------------*/
    [types.SET_CURRENT_POSITION]({ state, commit }) {
      if (state.current_position) {
        state.map.panTo([state.current_position.lat, state.current_position.lng]);
        if (state.offcanvas_is_show) {
          commit(types.TOGGLE_OFFCANVAS, false);
        }
      }
    },

    /*
      Toggle Guide 
    /*---------------------------------------*/
    [types.TOGGLE_GUIDE]({ commit }) {
      commit(types.TOGGLE_GUIDE);
    },

    /*
      Message 
    /*---------------------------------------*/
    [types.SET_MESSAGE]({ commit }, message) {
      commit(types.SET_MESSAGE, message);
    },

    /*
      Memo 
    /*---------------------------------------*/
    [types.SET_MEMO]({ commit }, memo) {
      commit(types.SET_MEMO, memo);
    },

    /*
      Popup and Panto
    /*---------------------------------------*/
    [types.POPUP]({ state, commit }, layer) {
      //- Popup and Panto
      layer.openPopup();
      //- Close offcanvas when paned to
      if (state.offcanvas_is_show) {
        commit(types.TOGGLE_OFFCANVAS, false);
      }
    },
  },
});
